/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Button, Drawer, MenuItem, Select } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface CancelPaymentFilterProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  setEndDate: (date: Dayjs | null) => void;
  handleSubmit?: (clearData?: any) => void;
  handleClearFilters: () => void;
  categoryId: string;
  setCategoryId: (value: string) => void;
  category: any[];
}
function CancelPaymentFilter({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSubmit,
  handleClearFilters,
  categoryId,
  setCategoryId,
  category,
}: CancelPaymentFilterProps) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const toggleDrawer = (open: boolean) => () => {
    setOpenDrawer(open);
  };

  const handleClearAll = () => {
    setStartDate(null);
    setEndDate(null);
    setOpenDrawer(false);
    handleSubmit?.(true);
    handleClearFilters();
  };

  return (
    <>
      <Button onClick={toggleDrawer(true)} className="btn btn_primary">
        <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
      </Button>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          handleClearAll();
        }}
        className="filter_drawer"
      >
        <div style={{ width: 420, padding: 20 }} className="filter_body">
          <div
            className="filter_head"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <h3>Filters</h3>
            <a onClick={handleClearAll} style={{ cursor: "pointer" }}>
              Clear All
            </a>
          </div>

          <div className="gap_m">
            <div className="w_50 control_group date_field">
              <label>Start Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  format="DD/MM/YYYY"
                  value={startDate}
                  slotProps={{
                    textField: {
                      placeholder: "Start Date",
                      sx: {
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#9999", // change text & placeholder color
                          opacity: 1,
                        },
                      },
                    },
                  }}
                  onChange={(newValue) => setStartDate?.(newValue)}
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                    // textField: (params) => (
                    //   <TextField
                    //     {...params}
                    //     fullWidth
                    //     placeholder="Start Date"
                    //     hiddenLabel
                    //   />
                    // ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
            <div className="w_50 control_group date_field">
              <label>End Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  value={endDate}
                  onChange={(newValue) => setEndDate?.(newValue)}
                  minDate={dayjs(startDate)}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      placeholder: "End Date",
                      sx: {
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#9999", // change text & placeholder color
                          opacity: 1,
                        },
                      },
                    },
                  }}
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                  disabled={!startDate}
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="control_group w_100">
            <Select
              name="page"
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
              displayEmpty
            >
              <MenuItem value={""} disabled>
                Category
              </MenuItem>
              {category?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </div>

          <div className="btn_flex">
            <Button
              className="btn btn_primary"
              onClick={() => {
                if (handleSubmit) {
                  handleSubmit();
                }
                setOpenDrawer(false);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default CancelPaymentFilter;
